import { Typography } from '@components/typography';
import { useTheme, type SxProps, type TypographyProps } from '@mui/material';
import type { ReactNode } from 'react';

export type ServerTagProps = {
  label: ReactNode | string;
  color?:
    | 'default'
    | 'success'
    | 'error'
    | 'warning'
    | 'workspace'
    | 'organization'
    | 'user'
    | 'platform'
    | 'service';
  variant?: TypographyProps['variant'];
  sx?: SxProps;
  fitContent?: boolean;
};

export const ServerTag = ({
  label,
  color = 'default',
  variant = 'body2',
  sx,
  fitContent = false,
}: ServerTagProps) => {
  const { palette } = useTheme();
  const foregroundColor =
    color === 'default'
      ? palette.foreground.paperCard.light
      : color === 'success'
        ? palette.resource.workspace.foreground
        : color === 'error'
          ? palette.error.main
          : color === 'warning'
            ? palette.foreground.paperCard.warning
            : color === 'workspace'
              ? palette.resource.workspace.foreground
              : color === 'organization'
                ? palette.resource.organization.foreground
                : color === 'user'
                  ? palette.resource.user.foreground
                  : color === 'platform'
                    ? palette.resource.platform.foreground
                    : color === 'service'
                      ? palette.resource.service.foreground
                      : palette.warning.contrastText;
  const backgroundColor =
    color === 'default'
      ? palette.background.paper
      : color === 'success'
        ? palette.resource.workspace.background
        : color === 'error'
          ? palette.error.light
          : color === 'warning'
            ? 'transparent'
            : color === 'workspace'
              ? palette.resource.workspace.background
              : color === 'organization'
                ? palette.resource.organization.background
                : color === 'user'
                  ? palette.resource.user.background
                  : color === 'platform'
                    ? palette.resource.platform.background
                    : color === 'service'
                      ? palette.resource.service.background
                      : palette.warning.light;
  const borderColor =
    color === 'workspace'
      ? palette.resource.workspace.border
      : color === 'organization'
        ? palette.resource.organization.border
        : color === 'user'
          ? palette.resource.user.border
          : color === 'platform'
            ? palette.resource.platform.border
            : color === 'service'
              ? palette.resource.service.border
              : foregroundColor;
  return (
    <Typography
      variant={variant}
      sx={{
        backgroundColor,
        color: foregroundColor,
        border: `1px solid ${borderColor}`,
        px: 1,
        borderRadius: 1,
        width: fitContent ? 'fit-content' : 'auto',
        ...sx,
      }}
    >
      {label}
    </Typography>
  );
};
